import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  ContentChild,
  TemplateRef,
  ViewEncapsulation,
} from '@angular/core';

import { Observable } from 'rxjs';

import { TrayItem } from '../../models/minimalizable.model';
import { TrayService } from '../../services/tray.service';

@Component({
  selector: 'semeris-tray',
  templateUrl: './tray.component.html',
  styleUrls: ['./tray.component.scss'],
  imports: [CommonModule],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TrayComponent {
  @ContentChild('trayItem') public itemTemplateRef: TemplateRef<any>;

  public readonly trayItems$: Observable<TrayItem[]>;

  constructor(private readonly trayService: TrayService) {
    this.trayItems$ = this.trayService.trayItems$;
  }

  public close = (item: TrayItem) => {
    this.trayService.close(item.id);
  };

  public restore = (item: TrayItem) => {
    this.trayService.restore(item.id);
  };
}
